import { FC, useState, useRef, useEffect } from "react";
import { convertChannelNameFee } from "../../lib/utils";
import { SearchIcon } from "src/components/icons/search-icon";
import {
  CurrencyDataType
} from "src/lib/constants/table-type";

interface IOption {
  name: string;
  id: number;
}
interface GroupedOptions {
  label: string;
  options: IOption[];
}
interface IService {
  label: string;
  code: number;
}

export interface ICurrencyDataType {
  key: React.Key;
  id: number;
  code: string;
  name: string;
  depositable: number;
  withdrawable: number;
}
interface IGroupCurrencyFilter {
  value: string;
  options: GroupedOptions[] ;
  onChange: (value: string, type: string) => void;
  type: string;
  categorySearch: string;
  setCategorySearch: (value: string) => void;
}

const CurrencyDrop: FC<IGroupCurrencyFilter> = ({
  value,
  options,
  onChange,
  type,
  categorySearch,
  setCategorySearch,
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const toggleDropdown = () => setOpen((prev) => !prev);

  const handleSelect = (val: any) => {
    onChange(val, type);
    setOpen(false);
  };

  const handleClickOutside = (e: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(e.target as Node)
    ) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  return (
    <div className="relative w-full" ref={dropdownRef}>
      <button
        type="button"
        className="w-full border border-[#e5e5ea] h-[48px] rounded-xl px-4 text-left bg-white"
        onClick={toggleDropdown}
      >
        <span className="text-sm font-medium">
          {type === "chanel"
            ? convertChannelNameFee(value)
            : value.toUpperCase()}
        </span>
        <span className="select__current-arrow absolute h-full flex items-center justify-center right-3 top-0">
          <svg
            className="stroke"
            width="8"
            height="5"
            viewBox="0 0 8 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L4 4L7 1"
              stroke="#424242"
              stroke-linecap="square"
            ></path>
          </svg>
        </span>
      </button>

      {open && (
        <div className="absolute mt-1 z-10 w-full bg-white border border-white rounded-xl shadow-lg max-h-60 overflow-y-auto">
           {/* <SearchIcon /> */}
          <input
            type="text"
            placeholder="Search..."
            value={categorySearch}
            onChange={(e) => setCategorySearch(e.target.value)}
          />
          {options.map((group) => (
            <div key={group.label} className="py-1">
              <div className="px-3 py-1 text-sm font-bold text-gray-500 uppercase">
                {group.label !== "All" && group.label}
              </div>
              {group.options.length > 0 ? (
                group.options.map((opt) => (
                  <button
                    key={opt.name}
                    type="button"
                    onClick={() => handleSelect(opt)}
                    className={`w-full text-left px-4 py-2 text-xs  ${
                      value === opt.name ? "bg-gray-100 font-bold" : ""
                    } hover:bg-[#ddd] font-semibold`}
                  >
                    {opt.name.toUpperCase()}
                  </button>
                ))
              ) : (
                <div className="px-4 py-2 text-sm text-gray-400 flex items-center">
                  <span className="w-[10px] border-t border-[#000]"></span>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

CurrencyDrop.displayName = "CurrencyDrop";
export default CurrencyDrop;
